"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputProviderController = exports.PadInput = void 0;
const KHInputKey_1 = require("./KHInputKey");
var PadInput;
(function (PadInput) {
    PadInput[PadInput["Left"] = 0] = "Left";
    PadInput[PadInput["Right"] = 1] = "Right";
    PadInput[PadInput["Up"] = 2] = "Up";
    PadInput[PadInput["Down"] = 3] = "Down";
    PadInput[PadInput["A"] = 4] = "A";
    PadInput[PadInput["B"] = 5] = "B";
    PadInput[PadInput["X"] = 6] = "X";
    PadInput[PadInput["Y"] = 7] = "Y";
    PadInput[PadInput["Select"] = 8] = "Select";
    PadInput[PadInput["Start"] = 9] = "Start";
    PadInput[PadInput["L1"] = 10] = "L1";
    PadInput[PadInput["R1"] = 11] = "R1";
})(PadInput = exports.PadInput || (exports.PadInput = {}));
class KHInputProviderController {
    constructor(scene, gamePadNumber) {
        this.scene = scene;
        this.gamePadNumber = gamePadNumber;
        this.buttons = new Map();
        this.buttons.set(PadInput.A, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.B, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.X, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Y, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Left, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Right, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Up, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Down, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Start, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.Select, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.L1, new KHInputKey_1.KHInputKey());
        this.buttons.set(PadInput.R1, new KHInputKey_1.KHInputKey());
    }
    updateDisconnect() {
        this.buttons.forEach((value, key) => {
            value.update(false);
        });
    }
    update(now, delta) {
        if (!this.scene.input.gamepad || this.gamePadNumber >= this.scene.input.gamepad.gamepads.length) {
            this.updateDisconnect();
            return;
        }
        let gamePad = this.scene.input.gamepad.gamepads[this.gamePadNumber];
        if (!gamePad) {
            this.updateDisconnect();
            return;
        }
        this.buttons.get(PadInput.A).update(gamePad.A);
        this.buttons.get(PadInput.B).update(gamePad.B);
        this.buttons.get(PadInput.X).update(gamePad.X);
        this.buttons.get(PadInput.Y).update(gamePad.Y);
        this.buttons.get(PadInput.Left).update(gamePad.left);
        this.buttons.get(PadInput.Right).update(gamePad.right);
        this.buttons.get(PadInput.Up).update(gamePad.up);
        this.buttons.get(PadInput.Down).update(gamePad.down);
        this.buttons.get(PadInput.Start).update(gamePad.getButtonValue(9) == 1);
        this.buttons.get(PadInput.Select).update(gamePad.getButtonValue(8) == 1);
        this.buttons.get(PadInput.L1).update(gamePad.L1 > 0.9);
        this.buttons.get(PadInput.R1).update(gamePad.R1 > 0.9);
    }
    getInput(input) {
        return this.buttons.get(input);
    }
    isDown(input) {
        return this.buttons.get(input).isDown();
    }
    isJustDown(input) {
        return this.buttons.get(input).isJustDown();
    }
}
exports.KHInputProviderController = KHInputProviderController;
